const apisConfig = {
  apis: {
    api:
      process.env.NODE_ENV === "production" && process.env.REACT_APP_HOST_ENV === "production"
        ? {
          protocol: "https",
          host: process.env.BACKEND_URI || "api.suarte.art",
          port: process.env.BACKEND_PORT || "443",
        }
        : {
          protocol: process.env.REACT_APP_BACKEND_PROTOCOL || process.env.BACKEND_PROTOCOL || "https",
          host: process.env.REACT_APP_BACKEND_URI || process.env.BACKEND_URI || "dev.suarte.art",
          port: process.env.REACT_APP_BACKEND_PORT || process.env.BACKEND_PORT || "443",
        },
  },
};

apisConfig.apis.api.url = `${apisConfig.apis.api.protocol}://${apisConfig.apis.api.host}:${apisConfig.apis.api.port}`;

export default apisConfig;
